import { Row, Col, Pagination, Typography, Tooltip, Select } from 'antd'
import { Field } from 'redux-form'
import _ from 'lodash'
import { FormLoader, AdditionalProductBtnModal, Icon, Button, Toast, PopoverImg } from '@vzmi/shp_shared_compo'
import { HistoryUtil } from '@vzmi/component_ec_nodejs_util/dist/lib'
import { getFeatureToggle } from '@vzmi/component_ec_nodejs_util/dist/lib/FeatureToggleUtil'
import { PROPOSAL_TYPE, PROPOSAL_PHASE_TYPE } from '@vzmi/shp_shared_compo/constants/proposal'
import CommonPage from '../../../containers/Proposal/Common/CommonPage'
import { withI13nWrapper } from '../../Common/I13nWrapper'
import { CheckboxInputField, HyperLink } from '../../Common/Form'
import withListingQueryForm from '../HOC/withListingQueryForm'
import styles from './QueryPage.css'
import HeadingWithId from '../../Proposal/Common/HeadingWithId/HeadingWithId'
import InvalidListingModal from '../../Proposal/Common/InvalidListingModal'
import { IconPopoverLabel } from '../../Proposal/Common/ProposalForm/FormLabelTooltip/FormLabelTooltip'
import QueryForm, { DEFAULT_REQUEST_SIZE } from './QueryForm/QueryForm'
import { ConnectedListingLink } from '../../Common/ListingLink/ListingLink'
import SPBaseModule from '../../../lib/SPBaseModule'
import ActionLink from './ActionLink/ActionLink'
import BtnModal from './BtnModal/BtnModal'
import DuplicatedProductModal from './DuplicatedProductModal'
import { EXTRA_MODEL, EXTRA_MODEL_GROUP } from '../../../constants/proposalTypes'
import { dollarFormat, numeralFormat } from '../../../../lib/renderUtil'
import { pruneEmpty } from '../../../lib/FormHelper'
import { COMMA } from '@vzmi/component_ec_nodejs_util/dist/lib/parserUtil'
import { getUpdateListingModelValidateResult } from '../../../lib/listingUtil'
import { getDuplicatedListingsGroupBySku } from '../../BatchProposal/helper/batch'
import { exportExcel } from './exportBatchUpdateImageHelper'
import { CDN } from '@vzmi/shp_shared_compo/dist/constants/cdn.js'

const pickSkuPartNoFrom = obj => {
  const picked = _.pick(obj, ['sku', 'partNo', 'cost', 'availableCount', 'isVisible'])
  if (picked.cost !== undefined) {
    picked.cost = dollarFormat(_.toNumber(picked.cost))
  }
  return picked
}
const getSpecValueFrom = obj => _.get(obj, 'spec.selectedValue', '')

const getProductItemsBy = listing => {
  const products = []

  const models = _.get(listing, 'models', [])
  const isNoModelsListing = _.isEmpty(models)
  if (isNoModelsListing) {
    products.push(pickSkuPartNoFrom(listing))
  } else {
    models.forEach(model => {
      const modelSpecValue = getSpecValueFrom(model)

      const items = _.get(model, 'items', [])
      const isNoItemsModel = _.isEmpty(items)
      if (isNoItemsModel) {
        products.push({
          ...pickSkuPartNoFrom(model),
          modelSpecValue
        })
      } else {
        items.forEach(item => {
          const itemSpecValue = getSpecValueFrom(item)
          products.push({
            ...pickSkuPartNoFrom(item),
            modelSpecValue,
            itemSpecValue
          })
        })
      }
    })
  }

  // apply keys to fix rc-table error
  _.forEach(products, (value, index) => {
    if (_.isEmpty(_.get(value, 'key', null))) {
      value.key = index.toString()
    }
  })

  return products
}

const getListingImage = listing => {
  const images = _.get(listing, 'images', _.get(listing, 'models[0].images', null))
  if (images) {
    const mainImage = _.pickBy(images, image => {
      if (image.order === 1 && image.height >= 1000) {
        return true
      }
    })
    if (!_.isEmpty(mainImage)) {
      return mainImage['0'].url || mainImage[0].url || ''
    }
  }
  return ''
}

const BATCH_SELECT_PREFIX = 'batch_select_'

const BATCH_SELECT_ALL_FIELD = 'batchSelectAll'

const getBatcchSelectName = listingId => {
  return `${BATCH_SELECT_PREFIX}${listingId}`
}

const getListingIdFromBatchSelectField = batchSelectField => {
  return _.replace(batchSelectField, BATCH_SELECT_PREFIX, '')
}

const checkIsBatchSelectField = fieldName => {
  return new RegExp(`^${BATCH_SELECT_PREFIX}`).test(fieldName)
}

const getSelectedListingIds = formValues => {
  const selectedListingIds = _.flow(
    () => _.keys(formValues),
    fields => _.filter(fields, checkIsBatchSelectField),
    batchSelectFields => _.filter(batchSelectFields, field => formValues[field]),
    selectFields => _.map(selectFields, getListingIdFromBatchSelectField)
  )()
  return selectedListingIds
}

const ImgDescription = props => {
  const {
    imgSrc,
    description,
    children
  } = props

  return (
    <div className={styles.newQueryPromo}>
      <img
        className={styles.newQueryImg}
        src={imgSrc}
      />
      <div className={styles.newQueryDescription}>
        {description}
      </div>
      {children}
    </div>
  )
}

const ResultsPagination = props => {
  const {
    total = 0,
    pageSize = 50,
    current = 1,
    onPageChange,
    onPageSizeChange
  } = props

  const handlePageSizeChange = value => {
    onPageSizeChange(value)
  }
  const pageSizeOptions = _.times(4, index => {
    const value = (index + 1) * 50
    return { label: `${value}`, value }
  })

  return (
    <section className={styles.resultsPaginationSection}>
      <Row
        type='flex'
        justify='end'
        align='middle'
      >
        <Col>
          {'永久停售之賣場已自動隱藏'}
        </Col>
        <Col>
          <span>
            {`共${total}筆，每頁`}
          </span>
          <Select
            defaultValue={pageSize}
            onChange={handlePageSizeChange}
            value={pageSize}
            options={pageSizeOptions}
          />
          <span>
            {'筆'}
          </span>
        </Col>
        <Col>
          <div className={styles.resultsListPagination}>
            <Pagination
              defaultCurrent={1}
              total={total}
              current={current}
              pageSize={pageSize}
              onChange={onPageChange}
              showSizeChanger={false}
            />
          </div>
        </Col>
      </Row>
    </section>
  )
}

const ListingActionLink = props => {
  const { action, id, onClick, validation } = props
  const { name, targetPath } = action
  const proposalType = _.replace(targetPath, '/proposal/', '')
  const targetURL = `${targetPath}/${PROPOSAL_PHASE_TYPE.COMPOSE}?listingId=${id}`
  let LinkComponent = (
    <ActionLink targetURL={targetURL}>
      {proposalType === PROPOSAL_TYPE.UPDATE_IMAGE
        ? (
          <IconPopoverLabel
            className={styles.labelWithIcon}
            popoverPlacement='left'
            popoverContent={(
              <PopoverImg
                url={`${CDN}/supplier/modify_image_description.png`}
                width={1434}
                height={698}
              />
            )}
          >
            {name}
          </IconPopoverLabel>
        )
        : name}
    </ActionLink>
  )
  switch (proposalType) {
    case PROPOSAL_TYPE.UPDATE_LISTING_MODEL: {
      if (validation.isValid) {
        break
      }
      LinkComponent = (
        <ActionLink
          onClick={onClick}
          data-role={proposalType}
        >
          {name}
        </ActionLink>
      )
      break
    }
    default:
      break
  }
  return (
    <div key={name}>
      {LinkComponent}
    </div>
  )
}

const BATCH_BTNS = [
  { type: PROPOSAL_TYPE.UPDATE_COPY, name: '批次修改詳情與保證', withCount: true },
  { type: PROPOSAL_TYPE.UPDATE_IMAGE, name: '批次修改圖片-WEB', withCount: true },
  { type: PROPOSAL_TYPE.UPDATE_ATTRIBUTE, name: '批次修改規格表', withCount: true },
  { type: PROPOSAL_TYPE.UPDATE_VIDEO, name: '批次修改影片', withCount: true }
]

const ACTION_TYPE = {
  EXPORT_LISTINGS: 'EXPORT_LISTINGS',
  IMPORT_LISTINGS: 'IMPORT_LISTINGS'
}

const ACTION_BTNS = [
  { type: ACTION_TYPE.EXPORT_LISTINGS, name: '匯出圖片資訊' },
  { type: ACTION_TYPE.IMPORT_LISTINGS, name: '批次修改圖片-上傳檔案', href: '/batchUpload/updateImage' },
  { type: ACTION_TYPE.IMPORT_LISTINGS, name: '查看批次修改圖片', href: '/proposal/batch/query' }
]

// FIXME: 未來所有批次都改成上限為 200 時，即可將 MAX_BATCH_UPDATE_COUNT 改為 200
const MAX_BATCH_UPDATE_COUNT = 50

export class QueryPage extends SPBaseModule {
  constructor (props) {
    super(props)

    this.state = {
      page: null,
      pageSize: null,
      hasQueried: false,
      listings: [],
      selectedListingIds: [],
      pagination: {},
      invalidListingModalVisible: false,
      invalidListing: {},
      invalidListingValidation: {},
      duplicatedProductModalVisible: false,
      duplicatedListingsGroupBySku: {},
      batchProposalType: null
    }
  }

  isFormLoading = () => this.state.isLoading || this.props.submitting

  setHasQueried = hasQueried => {
    // 重置批次勾選
    this.onSelectAllListingsChange(null, false)
    this.setState(() => ({ hasQueried }))
  }

  setListings = listings => {
    this.setState(() => ({ listings }))
  }

  setPagination = pagination => {
    this.setState(() => ({ pagination }))
  }

  handlePageChange = targetPage => {
    const { page: currentPage } = this.state
    if (targetPage !== currentPage) {
      this.setState(() => ({ page: targetPage }))
      // 重置批次勾選
      this.onSelectAllListingsChange(null, false)
    }
  }

  handlePageSizeChange = targetPageSize => {
    this.setState(() => ({
      page: 1,
      pageSize: targetPageSize
    }))
    // 重置批次勾選
    this.onSelectAllListingsChange(null, false)
  }

  renderPagination = () => {
    const {
      page,
      pageSize,
      pagination = {}
    } = this.state

    const { resultsTotal } = pagination

    return (
      <ResultsPagination
        pageSize={_.isNull(pageSize) ? DEFAULT_REQUEST_SIZE : pageSize}
        current={page}
        total={resultsTotal}
        onPageChange={this.handlePageChange}
        onPageSizeChange={this.handlePageSizeChange}
      />
    )
  }

  componentDidMount () {
    const { page: pageFromUrl, pageSize: pageSizeFromUrl } = pruneEmpty(HistoryUtil.retrieveQueryParams(this.props))
    const pageNumber = _.toNumber(pageFromUrl)
    const pageSizeNumber = _.toNumber(pageSizeFromUrl)
    if (pageNumber) {
      this.setState(() => ({ page: pageNumber }))
    }
    if (pageSizeNumber) {
      this.setState(() => ({ pageSize: pageSizeNumber }))
    }
  }

  openInvalidListingModal = (listing, validation) => () => {
    this.setState({
      invalidListing: listing,
      invalidListingValidation: validation,
      invalidListingModalVisible: true
    })
  }

  closeInvalidListingModal = () => {
    this.setState({
      invalidListing: {},
      invalidListingValidation: {},
      invalidListingModalVisible: false
    })
  }

  onSelectAllListingsChange = (e, isSelectAll) => {
    const { listings = [] } = this.state
    const {
      reduxFormState,
      initialize
    } = this.props
    const newFormValues = _.flow(
      // 取得 query listing redux form
      () => _.get(reduxFormState, 'values', {}),
      values => {
        // 過濾掉 redux form 內批次選擇欄位
        const fieldsWithoutBatchSelect = _.flow(
          () => _.keys(values),
          keys => _.filter(keys, checkIsBatchSelectField)
        )()
        // 重組 query listing redux form
        const formValues = {
          ..._.omit(values, fieldsWithoutBatchSelect),
          // 組出目前賣場的批次選擇欄位
          ..._.reduce(listings, (values, listing) => {
            const batchSelectFieldName = getBatcchSelectName(listing.id)
            values[batchSelectFieldName] = isSelectAll
            return values
          }, {}),
          // 批次全選或取消全選根據 isSelectAll 決定
          [BATCH_SELECT_ALL_FIELD]: isSelectAll
        }
        return formValues
      }
    )()
    // 避免逐個欄位修改會導致 rerender 次數過高，一次重新寫入整個 redux form
    initialize(newFormValues)
  }

  onSelectListingChange = (e, nextValue, currentValue, field) => {
    const { listings = [] } = this.state
    const {
      reduxFormState,
      change
    } = this.props
    const isSelectAll = _.flow(
      // 取得 query listing redux form
      () => _.get(reduxFormState, 'values', {}),
      values => {
        // 過濾掉 redux form 內批次選擇欄位
        const batchSelectFields = _.flow(
          () => _.keys(values),
          keys => _.filter(keys, key => {
            if (checkIsBatchSelectField(key)) {
              return (
                // 非觸發 onChange 欄位保留選擇賣場的欄位
                (key !== field && values[key]) ||
                // 觸發 onChange 欄位如果是選擇賣場則保留
                (key === field && nextValue)
              )
            }
            // 非批次欄位直接過濾
            return false
          })
        )()
        return _.isEqual(
          _.size(batchSelectFields),
          _.size(listings)
        )
      }
    )()
    change(BATCH_SELECT_ALL_FIELD, isSelectAll)
  }

  handleDuplicatedProducts = (proposalType, callback) => {
    const { reduxFormState } = this.props
    const { listings } = this.state
    const listingsMap = _.keyBy(listings, 'id')
    const formValues = _.get(reduxFormState, 'values', {})
    const selectedListingIds = getSelectedListingIds(formValues)
    const duplicatedListingsGroupBySku = getDuplicatedListingsGroupBySku(
      _.map(selectedListingIds, id => _.get(listingsMap, id))
    )
    // 選取的賣場沒有共用商品就可以執行 callback
    if (_.isEmpty(duplicatedListingsGroupBySku)) {
      this.setState(
        () => ({ batchProposalType: proposalType }),
        () => callback(selectedListingIds)
      )
      return
    }

    this.setState({
      duplicatedProductModalVisible: true,
      duplicatedListingsGroupBySku,
      selectedListingIds,
      batchProposalType: proposalType
    })
  }

  onBatchBtnClick = proposalType => () => {
    const { reduxFormState } = this.props
    const formValues = _.get(reduxFormState, 'values', {})
    const selectedListingIdsCount = _.size(getSelectedListingIds(formValues))
    const isLimit200 = [
      PROPOSAL_TYPE.UPDATE_VIDEO,
      PROPOSAL_TYPE.UPDATE_COPY,
      PROPOSAL_TYPE.UPDATE_ATTRIBUTE,
      PROPOSAL_TYPE.UPDATE_IMAGE
    ].includes(proposalType)

    // FIXME: 未來所有批次都改成上限為 200 時，即可移除 isLimit200 判斷, 並將 MAX_BATCH_UPDATE_COUNT 改為 200
    if (selectedListingIdsCount > MAX_BATCH_UPDATE_COUNT && !isLimit200) {
      return Toast.warning(`最多可同時修改 ${MAX_BATCH_UPDATE_COUNT} 筆賣場`)
    }

    this.handleDuplicatedProducts(proposalType, selectedListingIds => this.goToBatchUpdatePage(selectedListingIds))
  }

  goToBatchUpdatePage = listingIds => {
    const { batchProposalType } = this.state
    const selectedIdsStr = _.join(listingIds, COMMA)
    const path = `/proposal/batch/${batchProposalType}/${PROPOSAL_PHASE_TYPE.COMPOSE}`
    window.open(`${path}?listingIds=${selectedIdsStr}`)
  }

  cancelDuplicatedProductModal = () => {
    this.setState({
      duplicatedProductModalVisible: false
    })
  }

  exportBatchUpdateImageListings = () => {
    const { user, reduxFormState } = this.props
    const { listings } = this.state
    const formValues = _.get(reduxFormState, 'values', {})
    const selectedListings = _.flow(
      () => _.keyBy(getSelectedListingIds(formValues)),
      selectedListingIdMap => _.filter(listings, listing => (listing.id in selectedListingIdMap))
    )()
    const applicant = _.get(user, 'identity.name', '')
    exportExcel(selectedListings, applicant)
  }

  render () {
    const { reduxFormState } = this.props
    const {
      page,
      pageSize,
      hasQueried,
      listings = [],
      selectedListingIds = [],
      invalidListingModalVisible,
      invalidListing,
      invalidListingValidation,
      duplicatedProductModalVisible,
      duplicatedListingsGroupBySku
    } = this.state

    const {
      sharedLink: {
        scmStockQtyAdjust,
        scmProductCostPrice
      },
      subStationOptions,
      privilegedActions,
      flags
    } = this.props
    const { Paragraph } = Typography
    const formValues = _.get(reduxFormState, 'values', {})
    const selectedListingIdsCount = _.size(getSelectedListingIds(formValues))
    const hasResults = !_.isEmpty(listings)
    const isDisabledBatchBtn = (selectedListingIdsCount === 0)
    const updateImageFeatureToggle = getFeatureToggle(flags, 'sp_batchUpload')

    return (
      <CommonPage isHideNavigation={false}>
        <div className={styles.topContainer}>
          <section className={styles.querySection}>
            <HeadingWithId
              title='賣場查詢'
              subtitle='查詢賣場條件，開始修改賣場(複製賣場、修改賣場資訊、修改詳情與保證、修改圖片、修改規格表、調整賣場屬性項目、修改影片等)'
            />
            <div>
              <QueryForm
                {...this.props}
                page={page}
                pageSize={pageSize}
                handlePageSizeChange={this.handlePageSizeChange}
                handlePageChange={this.handlePageChange}
                getStateCache={this.getStateCache}
                setStateCache={this.setStateCache}
                setHasQueried={this.setHasQueried}
                setListings={this.setListings}
                setPagination={this.setPagination}
              />
            </div>
          </section>
          <FormLoader
            isLoading={this.isFormLoading()}
            fixed
          >
            <section className={styles.resultSection}>
              <Row>
                <Col
                  span={24}
                  className={styles.actionBtns}
                >
                  {BATCH_BTNS.map(({ type, name, withCount }) => {
                    return (
                      <Button
                        key={type}
                        size='large'
                        buttonType='outline'
                        onClick={this.onBatchBtnClick(type)}
                        disabled={withCount && isDisabledBatchBtn}
                      >
                        {name}
                        {withCount ? ` (${selectedListingIdsCount})` : ''}
                      </Button>
                    )
                  })}
                  {updateImageFeatureToggle && ACTION_BTNS.map(({ type, name, href }) => {
                    switch (type) {
                      case ACTION_TYPE.EXPORT_LISTINGS: {
                        return (
                          <Button
                            key={type}
                            size='large'
                            buttonType='outline'
                            disabled={isDisabledBatchBtn}
                            onClick={this.exportBatchUpdateImageListings}
                          >
                            {name}
                            {` (${selectedListingIdsCount})`}
                          </Button>
                        )
                      }
                      default: {
                        return (
                          <HyperLink
                            target='_blank'
                            href={href}
                            key={type}
                            isButton
                          >
                            <Button
                              size='large'
                              buttonType='outline'
                            >
                              {name}
                            </Button>
                          </HyperLink>
                        )
                      }
                    }
                  })}
                </Col>
                <Col
                  span={24}
                >
                  {hasResults && this.renderPagination()}
                </Col>
              </Row>
              {
                hasResults
                  ? (
                    <>
                      <div className={styles.resultsListTable}>
                        <div>
                          <Row
                            type='flex'
                            align='middle'
                            justify='space-between'
                            className={styles.resultsListHeader}
                          >
                            <Col span={1}>
                              <Field
                                name={BATCH_SELECT_ALL_FIELD}
                                component={CheckboxInputField}
                                onChange={this.onSelectAllListingsChange}
                              />
                            </Col>
                            <Col span={4}><span className={styles.listingId}>賣場編號</span></Col>
                            <Col span={8}> 賣場名稱 / 商品資訊</Col>
                            <Col span={4}> 子站</Col>
                            <Col
                              span={2}
                              className={styles.pullRightCol}
                            >
                              {' 可售數量'}
                            </Col>
                            <Col
                              span={2}
                              className={styles.pullRightCol}
                            >
                              {' 目前售價'}
                            </Col>
                            <Col
                              span={3}
                              push={1}
                            >
                              {' 操作'}
                            </Col>
                          </Row>
                        </div>
                        <div className={styles.resultsListBody}>
                          {
                            listings.map(
                              (listing, idx) => {
                                const {
                                  id,
                                  sku,
                                  name,
                                  swCode,
                                  price = 0,
                                  availableCount = 0,
                                  subStationId,
                                  skuSubStationId
                                } = listing

                                const formattedPrice = dollarFormat(_.toNumber(price))
                                const formattedAvailableCount = numeralFormat(_.toNumber(availableCount))

                                const matchedSubStation = subStationOptions.find(option => option.value === subStationId)
                                const subStationLabel = _.get(matchedSubStation, 'label', '')

                                const productItems = getProductItemsBy(listing)

                                const subNo = _.head(/\d+/.exec(skuSubStationId))
                                const productIds = _.get(listing, 'models[0].sku', sku)
                                const query = `?productIds=${productIds}&subNo=${subNo}`

                                const thumbnail = getListingImage(listing)
                                const thumbnailHtml = thumbnail
                                  ? (
                                    <span className={styles.thumbnail}>
                                      <img src={thumbnail} />
                                    </span>
                                  )
                                  : (
                                    <span className={styles.thumbnailEmpty} />
                                  )
                                const updateListingModelValidation = getUpdateListingModelValidateResult(listing)
                                const batchSelectFieldName = getBatcchSelectName(id)
                                return (
                                  <div key={idx}>
                                    <Row
                                      type='flex'
                                      justify='space-between'
                                      align='middle'
                                      className={styles.resultRow}
                                    >
                                      <Col span={1}>
                                        <Field
                                          name={batchSelectFieldName}
                                          component={CheckboxInputField}
                                          onChange={this.onSelectListingChange}
                                        />
                                      </Col>
                                      <Col span={4}>
                                        {
                                          _.map([thumbnailHtml, id], (element, index) => {
                                            const clz = index === 0 ? styles.hoverNoUnderLine : ''
                                            return (
                                              <ConnectedListingLink
                                                key={index}
                                                swCode={swCode}
                                                targetListingId={id}
                                                className={clz}
                                              >
                                                {element}
                                              </ConnectedListingLink>
                                            )
                                          })
                                        }
                                      </Col>
                                      <Col span={8}>
                                        <Tooltip
                                          title={name}
                                          placement='topLeft'
                                        >
                                          <Paragraph
                                            className={styles.productName}
                                            ellipsis={{ rows: 2 }}
                                          >
                                            {name}
                                          </Paragraph>
                                        </Tooltip>
                                        <div className={styles.btnModalsRow}>
                                          {/* 屬性商品 按鈕 */}
                                          <BtnModal
                                            btnProps={{ btnChildren: '商品' }}
                                            tableProps={{
                                              data: productItems,
                                              columns: [
                                                {
                                                  title: '商品編號',
                                                  dataIndex: 'sku',
                                                  key: 'sku',
                                                  width: 130
                                                },
                                                {
                                                  title: '規格項目',
                                                  dataIndex: 'modelSpecValue',
                                                  key: 'modelSpecValue',
                                                  width: 130,
                                                  render: (text, record) => {
                                                    const { modelSpecValue, itemSpecValue } = record
                                                    return (
                                                      <>
                                                        {modelSpecValue || '--'}
                                                        <div>
                                                          {itemSpecValue}
                                                        </div>
                                                      </>
                                                    )
                                                  }
                                                },
                                                {
                                                  title: '供應商商品料號',
                                                  dataIndex: 'partNo',
                                                  key: 'partNo',
                                                  width: 130
                                                },
                                                {
                                                  title: '可售數量',
                                                  dataIndex: 'availableCount',
                                                  key: 'availableCount',
                                                  width: 130
                                                },
                                                {
                                                  dataIndex: 'isVisible',
                                                  key: 'isVisible',
                                                  render: (text, record) => {
                                                    const isVisible = _.get(record, 'isVisible')
                                                    if (isVisible) {
                                                      return null
                                                    }

                                                    return (
                                                      <Icon
                                                        name='visible'
                                                        color='#979ba7'
                                                        size={16}
                                                        unallowed
                                                      />
                                                    )
                                                  }
                                                }
                                              ]
                                            }}
                                          />
                                          {/* 贈品 加價購按鈕 */}
                                          {
                                            _.map(EXTRA_MODEL, (property, index) => {
                                              const {
                                                title,
                                                subTitle,
                                                value
                                              } = property

                                              const isGift = _.includes([
                                                'complimentaries',
                                                'selectComplimentaries'
                                              ], value)

                                              const btnContent = isGift
                                                ? `${title}-${subTitle}`
                                                : title

                                              const models = listing[value]

                                              const foundGroupMap = _.find(
                                                _.values(EXTRA_MODEL_GROUP),
                                                { relatedModel: value }
                                              )
                                              const groups = foundGroupMap
                                                ? _.get(listing, foundGroupMap.value)
                                                : []
                                              if (models) {
                                                return (
                                                  <AdditionalProductBtnModal
                                                    key={index}
                                                    className={styles.additionalProductModalBtn}
                                                    name={btnContent}
                                                    items={models}
                                                    groups={groups}
                                                    tableProps={{
                                                      className: styles.additionalProductTable
                                                    }}
                                                  />
                                                )
                                              } else {
                                                return null
                                              }
                                            })
                                          }
                                        </div>
                                      </Col>
                                      <Col span={4}>{subStationLabel}</Col>
                                      <Col
                                        span={2}
                                        className={styles.pullRightCol}
                                      >
                                        <ActionLink targetURL={scmStockQtyAdjust}>
                                          {formattedAvailableCount}
                                        </ActionLink>
                                      </Col>
                                      <Col
                                        span={2}
                                        className={styles.pullRightCol}
                                      >
                                        <ActionLink targetURL={`${scmProductCostPrice}${query}`}>
                                          {formattedPrice}
                                        </ActionLink>
                                      </Col>
                                      <Col
                                        span={3}
                                        push={1}
                                        className={styles.actionsCol}
                                      >
                                        {
                                          privilegedActions.map((action, index) => {
                                            return (
                                              <ListingActionLink
                                                key={index}
                                                action={action}
                                                id={id}
                                                validation={updateListingModelValidation}
                                                onClick={this.openInvalidListingModal(listing, updateListingModelValidation)}
                                              />
                                            )
                                          })
                                        }
                                      </Col>
                                    </Row>
                                  </div>
                                )
                              }
                            )
                          }
                        </div>
                      </div>
                      {this.renderPagination()}

                    </>
                  )
                  : (
                    <ImgDescription
                      imgSrc={
                        hasQueried
                          ? `${CDN}/supplier/img_searchnodata_1567392001662.svg`
                          : `${CDN}/supplier/newQuery_1565174575410.svg`
                      }
                      description={
                        hasQueried
                          ? '查無賣場，請重新確認條件'
                          : '查詢賣場條件，開始修改賣場'
                      }
                    />
                  )
              }
            </section>
          </FormLoader>
        </div>
        <InvalidListingModal
          visible={invalidListingModalVisible}
          listing={invalidListing}
          validation={invalidListingValidation}
          width={445}
          onOk={this.closeInvalidListingModal}
          cancelButtonVisible={false}
          footer={null}
        />
        <DuplicatedProductModal
          visible={duplicatedProductModalVisible}
          selectedListingIds={selectedListingIds}
          duplicatedMap={duplicatedListingsGroupBySku}
          goToBatchUpdatePage={this.goToBatchUpdatePage}
          onCancel={this.cancelDuplicatedProductModal}
          width={700}
        />
      </CommonPage>
    )
  }
}

const hoc = _.flow([
  withI13nWrapper,
  withListingQueryForm
])

export default hoc(QueryPage)
